<template src="./Login.html"></template>
<style src="./Login.scss" lang="scss"></style>

<script>
	import Bento from '@/components/Bento/Bento';
	import Button from '@/components/Button/Button';
	import Input from '@/components/Input/Input';
	import Icon from '@/components/Icon/Icon';
	import { AdServiceWrapper, AD_BLOCKER_TYPES } from '@/services/wrapper/adServiceWrapper';

	/**
	 * The Login component on the page.
	 * @vue-data {'accent' | 'primary'} buttonImportance The color of the button mapped by importance
	 * @vue-data {string} ngUserId The NGUserID to be put in login as hidden field after it was received
	 * @vue-data {string} ibaInfo Some information about adblocker, os, browser and device class for target page
	 * @vue-data {string} brandName Current brand of page
	 * @vue-data {Object} emailInput Information about the email input field in login
	 * @vue-data {Object} passwordInput Information about the password input field in login
	 * @listens Document#abdDone
	 */
	export default {
		name: 'HpLogin',
		data () {
			return {
				buttonImportance: 'accent',
				ngUserId: '',
				ibaInfo: '',
				emailInput: {
					htmlId: 'loginfield',
					inputType: 'email',
					placeholder: 'E-Mail-Adresse',
					inputvalue: '',
					required: true,
					name: 'username'
				},
				passwordInput: {
					htmlId: 'passwordfield',
					inputType: 'password',
					placeholder: 'Passwort',
					inputvalue: '',
					required: true,
					name: 'password'
				},
				brandName: ''
			};
		},
		methods: {
			/**
			 * Actions to perform on login submit.
			 * @param {Event} event The click event of login button
			 */
			submit (event) {
				let form = this.$el.querySelector('form') || '';
				if (!form) {
					console.log('FORM not found');
					return;
				}
				let formValidity = true;
				for (let input of form.elements) {
					if (!input.checkValidity()) {
						input.setAttribute('aria-invalid', '');
						formValidity = false;
					}
				}
				!formValidity && event.preventDefault();
			}
		},
		beforeCreate () {
			document.addEventListener('bdDone', (event) => {
				this.ibaInfo = 'os=' + window.AdService.getParam('os') + ';browser=' + window.AdService.getParam('browser') + ';deviceclass=' + window.AdService.getParam('deviceclass') + ';abd=' + event.detail.abd;

				if (event.detail.adBlockerType === AD_BLOCKER_TYPES.trackingBlocker) {
					this.ibaInfo += ';deviceclient=' + window.AdService.getParam('deviceclient');
				}
			});
		},
		mounted () {
			this.brandName = process.env.VUE_APP_BRAND_NAME;
			if (this.brandName === 'WEB.DE') {
				this.buttonImportance = 'primary';
			}

			AdServiceWrapper.getNgUserIdCookie((ngUserId) => {
				console.log('NGUserID', ngUserId);
				this.ngUserId = ngUserId;
			});

			// get the sticky element
			if (document.querySelector('html').hasAttribute('data-content-login')) {
				let isSticky = false;
				let observer = new IntersectionObserver(
					function (entries) {
						// no intersection
						if (entries[0].intersectionRatio === 0) {
							document.querySelector('html').classList.add('stickyLogin');
							isSticky = true;
							// fully intersects
						} else if (entries[0].intersectionRatio === 1) {
							document.querySelector('html').classList.remove('stickyLogin');
							isSticky = false;
						}

						if (!window.SiteInfo) {
							window.SiteInfo = {};
						}
						window.SiteInfo.stickyLogin = isSticky;

						let event = new CustomEvent('loginStickyChanged', { bubbles: true, cancelable: true, detail: { source: 'Login.vue' } });
						document.querySelector('body').dispatchEvent(event);
					},
					{
						threshold: [0, 1]
					}
				);

				observer.observe(document.querySelector('[data-login-sticky-indicator]'));
			}
		},
		components: {
			'hp-bento': Bento,
			'hp-button': Button,
			'hp-input': Input,
			'hp-icon': Icon
		}
	};
</script>
